// src/i18n/en/metricLabels.ts
// English name of each v2 metric, keyed by the stable metric id the
// API sends (`MetricResultDto.id`, e.g. `ops.arrivals` -> metrics.ops.arrivals).
// The API's own `label` is only the fallback for an id missing here.
export const metricLabels = {
  chain: {
    arrivals: 'Arrivals',
    self_service_completed: 'Completed in self-service',
    containment: 'Resolved without reception',
    time_to_key_median: 'Time to key (median)',
    incidents: 'Incidents',
    availability: 'Roommatik device availability',
    stall_step: 'Step where most guests give up',
    pre_checkin_share: 'Arrivals with pre-check-in',
    median: 'Chain median',
    properties_with_rates: 'Hotels with data',
    ranking: 'Ranking by arrivals resolved without reception',
    config_chapter: 'Set-ups that work best in hotels like yours',
    mobile_key_adoption: 'Mobile keys: stays with a mobile key (chain)',
  },
  ops: {
    arrivals: 'Arrivals',
    arrivals_rooms: 'Arrival rooms',
    self_service_completed: 'Self-service completed',
    completed_without_key: 'Completed without a key',
    containment: 'Resolved without reception',
    awaiting_pms_confirmation: 'Awaiting confirmation from the reservation system',
    checked_in_by_staff: 'Check-ins done by staff',
    arrivals_by_end_state: 'Arrivals by state at the close of the day',
    self_service_incomplete_then_checked_in: 'Finished at reception after a self-service attempt',
    time_to_key_median: 'Time to key',
    time_to_key_p90: 'Time to key (9 out of 10)',
    journey_duration_median: 'Journey duration',
    incidents: 'Incidents',
    journeys_started: 'Journeys started',
    journeys_by_outcome: 'Journeys by outcome',
    completion_rate: 'Completion rate',
    handed_to_desk: 'Sent to reception',
    abandon_reasons: 'Reasons for giving up',
    step_funnel: 'Funnel by step',
    stall_share: 'Where guests give up',
    time_on_step_median: 'Time per step',
    attempt_fallback: 'Identification: from scan to manual',
    errors_by_component: 'Errors by component',
    error_rate: 'Journeys with an error',
    pre_checkin_share: 'Arrivals with pre-check-in',
    pre_checkin_funnel: 'Online pre-check-in',
    pre_checkin_resumed: 'Pre-check-ins resumed',
    keys_issued: 'Keys issued',
    key_failures: 'Key issuing failures',
    walkins: 'Walk-ins',
    three_sentences: 'Three things that changed',
    mobile_key_adoption: 'Mobile keys: stays with a mobile key',
    ces: 'Perceived ease (average from 1 to 5)',
  },
  board: {
    pending: 'Pending',
    at_device: 'At the kiosk',
    needs_help: 'Need someone',
    room_not_ready: 'Waiting for a room (room not ready)',
    awaiting_pms_confirmation: 'Awaiting confirmation from the reservation system',
    today_so_far: 'Today so far',
    device_strip: 'Devices',
    incidents_open: 'Open incidents',
    errors_now: 'Journeys with an error now',
  },
  fin: {
    payments_accepted: 'Payments accepted in self-service',
    payments_declined: 'Payments declined or failed',
    payments_posted: 'Confirmed by the kiosk',
    payment_unreconciled: 'Payments not confirmed',
    orphaned: 'Orphaned amounts',
    refunds: 'Refunds',
    reconciliation_rate: 'Reconciliation rate',
    cash_handled: 'Cash',
    tourist_tax: 'Tourist tax collected',
  },
  it: {
    availability: 'Availability',
    unknown_share: 'Time without signal',
    silent_devices: 'Devices without signal',
    down_time: 'Downtime',
    incidents: 'Incidents',
    time_to_resolve_median: 'Time to resolve',
    time_to_acknowledge_median: 'Time to acknowledge',
    detection_lag: 'Detection delay',
    peripheral_faults: 'Faults by peripheral',
    consumables_low: 'Low consumables',
    pms_link: 'Connection with the reservation system',
    feed_freshness: 'Age of the reservation data',
    reconciliation_gap: 'Discrepancies with the reservation system',
    unmatched_journeys: 'Journeys without a reservation in the data received',
    ingest_gaps: 'Gaps in the data received',
    rejected_events: 'Rejected events',
    software_versions: 'Software versions in use',
    remote_sessions: 'Remote sessions',
    mode_changes: 'Mode changes',
  },
  fit: {
    completion_rate: 'Completion rate by version and set-up',
    time_on_step: 'Time per step by version',
    time_to_key: 'Time to key by version',
    attempts_per_step: 'Attempts per step',
    first_attempt_success: 'First-attempt success by method',
    method_fallback: 'Method change',
    step_error_rate: 'Errors per step',
    stall_share: 'Where guests give up, by version',
    backtrack_share: 'Going back by step',
    skip_consistency: 'Skipped steps by reason',
    language_share: 'Sessions by language',
    ces: 'Perceived ease by version and set-up (average from 1 to 5)',
  },
};

export default metricLabels;
